module.exports = __webpack_public_path__ + "static/media/ottawa-19.b36bdb66.jpg";